import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';

export interface MenuVersionState {
  menuVersion: 1 | 2;
}

@Module({ namespaced: true, name: 'menuVersion' })
export default class MenuVersion extends VuexModule implements MenuVersionState {
  public menuVersion: 1 | 2 = 2;

  @Mutation
  public SET_MENU_VERSION(version: 1 | 2) {
    this.menuVersion = version;
    localStorage.setItem('menuVersion', version.toString());
  }

  @Action
  public initializeMenuVersion() {
    const savedVersion = localStorage.getItem('menuVersion');
    const defaultVersion: 1 | 2 = 2;

    if (savedVersion) {
      // Validate the parsed value before committing
      const parsedVersion = parseInt(savedVersion, 10);

      if (Number.isFinite(parsedVersion) && (parsedVersion === 1 || parsedVersion === 2)) {
        // Valid saved preference - use it
        this.context.commit('SET_MENU_VERSION', parsedVersion as 1 | 2);
      } else {
        // Corrupted or invalid value - reset to default and clean up localStorage
        console.warn(
          `[MenuVersion] Invalid menuVersion in localStorage: "${savedVersion}". Resetting to default.`
        );
        localStorage.removeItem('menuVersion');
        this.context.commit('SET_MENU_VERSION', defaultVersion);
      }
    } else {
      // New user - default to v2
      this.context.commit('SET_MENU_VERSION', defaultVersion);
    }
  }
}
